import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import ActivityListItem from '../../components/shared/activitylist/ActivityListItem';
import AttachmentLink from '../../components/shared/attachmentlink/AttachmentLink';
import DocumentFavorite from '../../components/shared/attachmentlink/DocumentFavorite';
import AttachmentIcon from '../../components/shared/attachmentlink/AttachmentIcon';
import Icon from '../../components/shared/icon/Icon';
import TagsItem from '../../components/shared/tags/TagsItem';
import FileTypeTeams from '../../components/shared/filetypes/Teams';

import { IApplicationState } from '../../store/applicationState';
import { IGroup, IMeeting } from '../../store/group/groupState';

import * as helpers from '../../genericExtensions';

interface IOwnProps {
    meeting: IMeeting;
    group: IGroup;
}

interface IStateProps {
    user: any;
}

type Props = IOwnProps & IStateProps;

class MeetingListItem extends React.Component<Props, {}> {
    public render() {
        if (this.props.meeting.status === 'Cancelled') {
            return null;
        }

        const participantStatus = this.props.user && this.props.meeting.participantStatuses.firstOrDefault(ps => ps.member.diNumber === parseInt(this.props.user.profile.Id, undefined));

        return <ActivityListItem link={`/Group/${this.props.group && this.props.group.reference}/Meeting/${this.props.meeting.meetingId}`} startTime={this.props.meeting.startTime} hasArrow={true} tags={this.renderTag}>
            {participantStatus && participantStatus.status !== 'NEEDS-ACTION' &&
                <p className="meta">
                    <Icon name={this.renderParticipantStatusIcon(participantStatus.status)} />
                    <strong>{helpers.participantStatusMap[participantStatus.status]}</strong>
                </p>
            }
            <h2 className={`activity-list__item__body__title`.cAppend(this.props.meeting.status === 'Cancelled', 't--strike')}>{this.props.meeting.subject}</h2>
        </ActivityListItem>;
    }

    private get renderTag() {
        return <Fragment>
            {this.props.meeting.documents.map((document, index) => {
                return <li key={index} className="tags__list__item">
                    <AttachmentLink className="button button--tag" document={document} title={document.fileName}>
                        <DocumentFavorite id={document.id} groupId={document.groupId} meetingId={this.props.meeting!.meetingId} isFavorite={document.isFavorite} />
                        <AttachmentIcon mimeType={document.mimeType} />
                        {document.fileName.length > 20 ? <React.Fragment>{document.fileName.substring(0, 18)}&hellip;</React.Fragment> : document.fileName}
                    </AttachmentLink>
                </li>
            })}
            {this.props.meeting.links.map((link, index) => {
                return <TagsItem key={index} url={link.link}>
                    {link.typeId === 'MSTeamsMeeting' && <FileTypeTeams />}
                    {link.typeId === 'EventRegistration' && <Icon name={link.icon} />}
                    {link.typeId !== 'MSTeamsMeeting' && link.typeId !== 'EventRegistration' && <Icon name="external-link" />}
                    {link.text === '' || link.text === link.link
                        ? link.typeId === 'MSTeamsMeeting' ? 'Join meeting' : 'Tilmeld arrangement'
                        : link.text
                    }
                </TagsItem>;
            })}
        </Fragment>
    }

    private renderParticipantStatusIcon(status: string) {
        switch (status) {
            case 'ACCEPTED':
                return 'checkmark';
            case 'DECLINED':
                return 'remove';
            default:
                return 'question';
        }
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    user: state.oidc.user
});

const container = connect(mapStateToProps)(MeetingListItem);

export default container;